import React, { useState } from "react";
import i18n from "i18next";
import { Select, MenuItem, Box, Typography } from "@mui/material";

const languages = [
  { code: "en", label: "English", flag: "/flags/en.png", emoji: "🇬🇧" },
  { code: "no", label: "Norsk", flag: "/flags/no.png", emoji: "🇳🇴" },
  { code: "el", label: "Ελληνικά", flag: "/flags/el.png", emoji: "🇬🇷" },
  { code: "ja", label: "日本語", flag: "/flags/ja.png", emoji: "🇯🇵" },
  { code: "fi", label: "Suomi", flag: "/flags/fi.png", emoji: "🇫🇮" },
];

const LanguageSelector: React.FC = () => {
  const [lang, setLang] = useState(i18n.language || "en");
  const [imgError, setImgError] = useState(false);

  const handleChange = (event: any) => {
    const selectedLang = event.target.value;
    setLang(selectedLang);
    i18n.changeLanguage(selectedLang);
    setImgError(false);
  };

  const langObj = languages.find((l) => l.code === lang);

  return (
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      <Select
        value={lang}
        onChange={handleChange}
        variant="standard"
        disableUnderline
        size="small"
        sx={{
          width: 60,
          padding: 0,
          textAlign: "center",
          color: "white",
          border: "1px solid transparent",
          borderRadius: "5px",
          transition: "border-color 0.2s ease",
          "&:hover": {
            borderColor: "white",
          },
          "& .MuiSelect-select": {
            padding: "4px",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          },
          "& .MuiSelect-icon": {
            color: "white",
          },
        }}
        renderValue={() =>
          imgError || !langObj?.flag ? (
            <span style={{ fontSize: 24 }}>{langObj?.emoji}</span>
          ) : (
            <img
              src={langObj.flag}
              alt={langObj.label}
              style={{ width: 30, height: 27 }}
              onError={() => setImgError(true)}
            />
          )
        }
      >
        {languages.map((lng) => (
          <MenuItem
            key={lng.code}
            value={lng.code}
            sx={{
              theme: "dark",
              backgroundColor: "primary.main",
              color: "secondary.main",
              "&.Mui-selected": {
                backgroundColor: "primary.dark",
                color: "secondary.main",
              },
              "&.Mui-selected:hover, :hover": {
                backgroundColor: "primary.dark",
              },
            }}
          >
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                gap: 1,
              }}
            >
              <img
                src={lng.flag}
                alt={lng.label}
                style={{
                  width: 30,
                  height: 27,
                  borderRadius: 2,
                }}
                onError={(e) => {
                  (e.target as HTMLImageElement).style.display = "none";
                }}
              />
              <Typography variant="body2">{lng.label}</Typography>
            </Box>
          </MenuItem>
        ))}
      </Select>
    </Box>
  );
};

export default LanguageSelector;
